import { Action, Module, Mutation } from 'vuex-module-decorators'
import BaseStore from '@/store/BaseStore'
import { GetReserveContactsRequest, reserveApi, ReserveContact } from '@/api'

@Module({
  name: 'ReservationContactPageStore',
  namespaced: true,
  stateFactory: true
})
export default class ReservationContactPageStore extends BaseStore {
  reserveContacts: ReserveContact[] = []

  get getReserveContacts(): ReserveContact[] {
    return this.reserveContacts
  }

  @Mutation
  public reset() {
    this.reserveContacts = []
  }

  @Mutation
  public setReserveContacts(array: ReserveContact[]) {
    this.reserveContacts = array
  }

  @Action({ rawError: true })
  public async fetchReserveContacts(request: GetReserveContactsRequest) {
    const items: ReserveContact[] = await reserveApi.getReserveContacts(request)
    this.setReserveContacts(items)
  }
}
